import React from "react";

import Lamina24img from "../images/lamina24img.png";
import Lamina24actividad from "../images/lamina24actividad.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  purple: {
    color: theme.palette.purple.main,
    borderColor: theme.palette.purple.main,
  },
  blueIcon: {
    backgroundColor: "#00aeef",
    color: "#fff",
    width: 25,
    height: 25,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: 700,
  },
  yellowIcon: {
    backgroundColor: "#ffcb05",
    color: "#fff",
    width: 25,
    height: 25,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: 700,
  },
  actText: {
    display: "flex",
    marginBottom: 10,
  },
  actContent: {
    borderBottom: "1px solid",
    minWidth: 280,
    marginLeft: 10,
    minHeight: 25,
  },
}));

const Lamina24 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 24: La democracia y las elecciones"
        meta={[
          {
            property: "og:title",
            content: "Lámina 24: La democracia y las elecciones",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "El Perú es una república democrática. Eso significa que el pueblo tiene derecho a participar de la toma de decisiones y el control de su gobierno. ",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="23" color="purple" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Title
          title="La democracia y las elecciones"
          color="purple"
          size="md"
        />
        <p>
          El Perú es una república democrática. Eso significa que el pueblo
          tiene derecho a participar de la toma de decisiones y el control de su
          gobierno. Una de las formas de hacerlo es por medio de las elecciones.
          En ellas elegimos a las personas que nos representarán y gobernarán.
        </p>
        <p>
          <strong>
            Para que las elecciones sean transparentes y justas, deben seguir un
            proceso ordenado. El Jurado Nacional de Elecciones es responsable de
            organizar el proceso electoral. Durante las elecciones encontramos
            lo siguiente:
          </strong>
        </p>
        <img src={Lamina24img} alt="Democracia" />
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="purple" />
        <p>
          <strong>Imagina que debes participar en elecciones. </strong> Observa
          la siguiente imagen y los recuadros. En ellos se presentan algunos
          criterios que podrían ser considerados al momento de elegir un
          candidato.
        </p>
        <img src={Lamina24actividad} alt="Actividad" />
        <p>
          Escoge los 3 criterios que te parezcan más importantes y ordénalos
          según su relevancia en la siguiente lista. Luego, conversa con un
          miembro de tu familia y pídele que haga su propia lista.
        </p>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <h4 style={{ color: "#00aeef" }}>MI LISTA:</h4>
            <div className={classes.actText}>
              <div className={classes.blueIcon}>1</div>
              <div className={classes.actContent}></div>
            </div>
            <div className={classes.actText}>
              <div className={classes.blueIcon}>2</div>
              <div className={classes.actContent}></div>
            </div>
            <div className={classes.actText}>
              <div className={classes.blueIcon}>3</div>
              <div className={classes.actContent}></div>
            </div>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <h4 style={{ color: "#ffcb05" }}>LA LISTA DE MI FAMILIAR:</h4>
            <div className={classes.actText}>
              <div className={classes.yellowIcon}>1</div>
              <div className={classes.actContent}></div>
            </div>
            <div className={classes.actText}>
              <div className={classes.yellowIcon}>2</div>
              <div className={classes.actContent}></div>
            </div>
            <div className={classes.actText}>
              <div className={classes.yellowIcon}>3</div>
              <div className={classes.actContent}></div>
            </div>
          </Grid>
        </Grid>
        <p>
          Ahora señalen un criterio que no se deba considerar al momento de
          decidir.
        </p>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <div className={classes.actText}>
              <div className={classes.actContent}></div>
            </div>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <div className={classes.actText}>
              <div className={classes.actContent}></div>
            </div>
          </Grid>
        </Grid>
        <p>
          <strong>
            Reflexionen juntos sobre los listados que han elaborado.
          </strong>
        </p>
        <p>
          ¿Por qué creen que estos criterios nos llevarían a elegir a las
          personas más adecuadas? ¿Cuál de ellos consideran que es el más
          importante? ¿Por qué?
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-24.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.purple }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 24: La democracia y las elecciones'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="La importancia de cuidar nuestras lenguas"
        anteriorEnlace="/lamina-1-23"
        siguiente="¿Quiénes nos gobiernan?"
        siguienteEnlace="/lamina-1-25"
      />
    </>
  );
};

export default Lamina24;
